<template>
    <div class="flex flex-col gap-4 h-full w-full min-w-0 overflow-y-auto overflow-x-hidden pt-20 xl:pt-8 p-4">
        <div class="mb-6">
            <h1 class="text-2xl sm:text-3xl font-bold text-foreground text-eblack-900">{{ $t("provider.auto.proveedores") }}</h1>
        </div>

        <div class="grid gap-4 sm:gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mb-6">
            <div class="border rounded-2xl border-ewhite-200 bg-gradient-to-br from-white to-ewhite-50">
                <div class="p-8">
                    <div class="flex items-center justify-between">
                        <div class="space-y-1">
                            <p class="text-sm font-medium text-muted-foreground">{{ $t("provider.auto.total_proveedores") }}</p>
                            <p class="text-2xl font-bold text-foreground">{{ overview.total }}</p>
                        </div>
                        <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100">
                            <IconUsers class="h-6 w-6 text-blue-600" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="border rounded-2xl border-ewhite-200 bg-gradient-to-br from-white to-ewhite-50">
                <div class="p-8">
                    <div class="flex items-center justify-between">
                        <div class="space-y-1">
                            <p class="text-sm font-medium text-muted-foreground">{{ $t("provider.auto.activos") }}</p>
                            <p class="text-2xl font-bold text-foreground">{{ overview.active }}</p>
                        </div>
                        <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-egreen-100">
                            <IconUserCheck class="h-6 w-6 text-egreen-600" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="border rounded-2xl border-ewhite-200 bg-gradient-to-br from-white to-ewhite-50">
                <div class="p-8">
                    <div class="flex items-center justify-between">
                        <div class="space-y-1">
                            <p class="text-sm font-medium text-muted-foreground">{{ $t("provider.auto.inactivos") }}</p>
                            <p class="text-2xl font-bold text-foreground">{{ overview.inactive }}</p>
                        </div>
                        <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-eblack-100">
                            <IconUserX class="h-6 w-6 text-eblack-600" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-6">
            <button type="button"
            class="bg-egreen-400 w-auto text-white px-4 py-1.5 rounded-lg text-md inline-flex justify-center items-center gap-2"
            @click="showModal()">
                <span >
                    <svg  
                    xmlns="http://www.w3.org/2000/svg"   
                    width="24" 
                    height="24"  
                    viewBox="0 0 24 24"  
                    fill="none"  
                    stroke="currentColor"  
                    stroke-width="2"  
                    stroke-linecap="round"  
                    stroke-linejoin="round" 
                    class="w-5 h-5 "><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M9 12h6" /><path d="M12 9v6" /></svg>
                </span>
                <span>{{ $t("provider.auto.agregar") }}</span>
            </button>

            <div class="flex gap-2">
                <OrderBy :apply-order-by="applyOrderBy" />
    
                <CategoryFilter ref="filterCategory" :setFilters="setFilters" />
            </div>

            <div class="relative flex-1 w-full md:w-80 md:ml-auto">
                <IconSearch class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <input 
                type="text" 
                name="search"
                v-model="search" 
                class="rounded-lg border-ewhite-300 text-md w-full md:w-80 focus:ring-blue-500 px-4 py-1.5 pl-9"
                :placeholder="$t('provider.auto.proveedor')">
            </div>
        </div>

        <ProviderCard ref="providerCard" 
        :search="search" 
        :show-modal="showModal" 
        :set-overview="setOverview"
        :filters="filters" 
        :order-by="orderBy" />
    </div>
</template>

<script>
import ProviderCard from './components/ProviderCard.vue';
import ProviderFormSidebar from './components/ProviderFormSidebar.vue';
import CategoryFilter from './components/CategoryFilter.vue';
import OrderBy from './components/OrderBy.vue';
import { useOverlay } from '@/services/overlay-service';
import { createSidebarConfig } from '@/utils/overlay-utils';
import { IconSearch, IconUserCheck, IconUsers, IconUserX } from '@tabler/icons-vue';

export default {
    name:'ProviderPage',
    data(){
        return {
            provider:null,
            errors:[],
            search:'',
            categorySelected:"",
            showDetails:false,
            orderBy:"",
            currentOverlayId: null,
            filters:{
                category:"",
                country:"",
                location_one:"",
                location_two:"",
            },
            overview:{
                total:0,
                active:0,
                inactive:0
            }
            
        }
    },
    setup() {
        const overlayService = useOverlay();
        return { overlayService };
    },
    components:{
        ProviderCard,
        CategoryFilter,
        OrderBy,
        IconUsers,
        IconUserCheck,
        IconUserX,
        IconSearch
    },
    methods:{
        showModal(provider=null, isDetails = false){
            this.provider = provider;
            this.showDetails = isDetails;
            
            this.currentOverlayId = this.overlayService.open(
                createSidebarConfig({
                    component: ProviderFormSidebar,
                    props: {
                        provider: this.provider,
                        showDetails: this.showDetails,
                        handleRequestInitData: this.handleRequestInitData,
                        overlayService: this.overlayService
                    },
                    onClose: () => {
                        this.provider = null;
                        this.showDetails = false;
                        this.currentOverlayId = null;
                    }
                })
            );
        },
        handleRequestInitData(){
            this.$refs.providerCard.initData();
        },
        setCategorySelected(category){
            this.categorySelected = category
        },
        applyOrderBy(type){
            this.orderBy = type
        },
        setFilters(filters){
           this.filters = filters
        },
        setOverview(overview){
            this.overview = overview
        }
    },
    mounted(){

    }
}
</script>

<style lang="scss" scoped>

</style>